/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable default-case */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Component, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormService } from 'src/app/shared/services/form.service';
import { MessageModalComponent } from 'src/app/shared/components/message-modal/message-modal.component';
import { tableColumns } from 'src/app/shared/constants/table-column.constants';
import { Subject, combineLatest, takeUntil } from 'rxjs';
import { NotesComponent } from 'src/app/shared/components/notes/notes.component';
import { SetStatusComponent } from 'src/app/shared/components/set-status/set-status.component';
import { PrecastService } from 'src/app/shared/services/precast.service';
import { INotes } from 'src/app/features/models/inotes.modal';
import { PrecastWorksheet } from 'src/app/features/worksheet/models/precast-worksheet.modal';
import { WorksheetResponse } from 'src/app/features/worksheet/models/worksheet-response.modal';
import { UserService } from 'src/app/shared/services/user.service';
import { ProjectDetailsComponent } from 'src/app/shared/components/project-details/project-details.component';
import { IDropdown } from 'src/app/shared/models/i-dropdown-type.modal';
import { AdminHeader } from 'src/app/shared/models/admin-header.model';
import { WorksheetService } from './services/worksheet.service';
import { SharedService } from '../service/shared.service';
import { ExportTableService } from '../service/export-table.service';
import { DateTimeUtils } from 'src/app/shared/util/date-time.utils';
import { InstructionsComponent } from 'src/app/shared/components/instructions/instructions.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NativesoilTableComponent } from './components/nativesoil-table/nativesoil-table.component';
import { PrecastTableComponent } from './components/precast-table/precast-table.component';

@Component({
    selector: 'app-worksheet',
    templateUrl: './worksheet.component.html',
    styleUrls: ['./worksheet.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WorksheetComponent implements OnInit, OnDestroy {
  @ViewChild(MatPaginator) worklistPaginator!: MatPaginator;
  @ViewChild('nativeSoilTable')
  nativeSoilTableComponent!: NativesoilTableComponent;
  @ViewChild('precastTable')
  precastTableComponent!: PrecastTableComponent;
  public worksheetRecords!: WorksheetResponse;
  public displayedColumns: string[] = tableColumns.worksheetColumns;
  public dataSource = new MatTableDataSource<PrecastWorksheet>();
  public dialogRef: MatDialogRef<NotesComponent> | undefined;
  public messageDialogRef: MatDialogRef<MessageModalComponent> | undefined;
  public statusDialogRef: MatDialogRef<SetStatusComponent> | undefined;
  public projectId = '';
  public soilType = '';
  public precastSampleId?: string | undefined;
  public note: INotes | undefined;
  private readonly destroyed$ = new Subject<boolean>();
  ovenDate = '';
  wetTestData = '';
  dryTestData = '';
  noteText: string | undefined = '';
  isReportWriter = false;
  sampleReceivedDate = '';
  dueDate = '';
  instructionConfirmedAt = '';
  instructionsConfirmed = false;
  daysleft: number | null;
  isRushTesting = false;
  isGeoTesting = false;
  preApprovalTesting = false;
  hasAsReceivedMC: boolean = false;
  @Input() FetchAllHeaderData: any;
  headerData: any;
  rowData: any;
  setRefresh = true;
  projectStatuses: IDropdown[];
  projectStatusId: any;
  userRoles: string[];
  constructor(
    private precastService: PrecastService,
    private activatedRoute: ActivatedRoute,
    public dialogService: DialogService,
    private router: Router,
    public dialog: MatDialog,
    public userService: UserService,
    private worksheetService: WorksheetService,
    private formService: FormService,
    private sharedService: SharedService,
    private exporttableService: ExportTableService,
    private snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.projectId = params['projectId'];
      this.soilType = params['soilType'];
      this.fetchWorksheetDetails(this.projectId);
      this.fetchWorksheetNotes(this.projectId);
    });
    this.userAccountAndRole();
    this.precastService.fetchProjectStatuses().subscribe({
      next: (projectStatues) => {
        this.projectStatuses = projectStatues;
      },
    });
  }

  userAccountAndRole() {
    this.userService.userRole?.subscribe({
      next: (roles) => {
        this.userRoles = roles || [];
        this.isReportWriter = this.userService.roleCheckExact('Reportwriter');
      }
    });
  }

  roleCheck(roles: string[]): boolean {
    return roles.some((role) => this.userRoles.includes(role));
  }

  refresh(): void {
    this.setRefresh = false;
    this.fetchWorksheetDetails(this.projectId);
    this.fetchWorksheetNotes(this.projectId);
    setTimeout(() => {
      this.setRefresh = true;
    }, 3);
  }

  onRowDeletionSuccess() {
    this.fetchWorksheetNotes(this.projectId);
  }

  fetchWorksheetNotes(projectID: string): void {
    this.sharedService.fetchWSNotes(projectID);
    this.sharedService.notes$.subscribe((data) => {
      this.note = data;
    });
    this.sharedService.notesText$.subscribe((data) => {
      this.noteText = data;
    });
  }

  fetchWorksheetDetails(projectId: string): void {
    this.formService.fetchFormData(projectId, this.soilType).subscribe({
      next: (result) => {
        const project = result?.project;
        const company = result?.company;
        const comments = result?.comments;
        this.worksheetRecords = {
          project,
          company,
          comments
        };
        this.projectStatusId = this.worksheetRecords.project.projectStatusTypeId;
        Object.assign(this.worksheetRecords, company);
        this.instructionConfirmedAt = this.worksheetRecords.project.instructionsConfirmedAt
          ? this.worksheetRecords.project.instructionsConfirmedAt
          : '';
        this.instructionsConfirmed = this.worksheetRecords.project.instructionsConfirmed
          ? this.worksheetRecords.project.instructionsConfirmed : false;
        this.dueDate = this.worksheetRecords.project.dueDate ? this.worksheetRecords.project.dueDate : '';
        this.sampleReceivedDate = this.worksheetRecords.project.sampleReceivedDate
          ? this.worksheetRecords.project.sampleReceivedDate
          : '';
        this.ovenDate = this.worksheetRecords.project.ovenDate ? this.worksheetRecords.project.ovenDate : '';
        this.wetTestData = this.worksheetRecords.project.wetTestData ? this.worksheetRecords.project.wetTestData : '';
        this.dryTestData = this.worksheetRecords.project.dryTestData ? this.worksheetRecords.project.dryTestData : '';
        this.isRushTesting = this.worksheetRecords.project.rushTesting
          ? this.worksheetRecords.project.rushTesting
          : false;
        this.isGeoTesting = this.worksheetRecords.project.geothermField
          ? this.worksheetRecords.project.geothermField
          : false;
        this.preApprovalTesting = this.worksheetRecords.project.preApproval
          ? this.worksheetRecords.project.preApproval
          : false;
        this.dataSource.paginator = this.worklistPaginator;
        if (this.dueDate) {
          const today = new Date();
          const dueDate = new Date(DateTimeUtils.getLocalDateTimeFromUTCDate(this.dueDate));
          this.daysleft = this.findDateDifference(today, dueDate);
        } else {
          this.daysleft = null;
        }
      },
    });
  }

  findDateDifference(startDate: Date, endDate: Date) {
    const timeDifference = Math.abs(endDate.getTime() - startDate.getTime());
    const dayDifference = timeDifference / (1000 * 3600 * 24);
    return Math.trunc(dayDifference);
  }

  isTestingInProgeress(): boolean {
    if (!this.projectStatuses || !this.projectStatusId) {
      return false; // don't check if data isn't ready
    }

    const testingStatus = this.projectStatuses.find(status => status.label === 'Testing In Progress');
    return testingStatus ? this.projectStatusId === testingStatus.id : false;
  }

  openViewNotesDialog(): void {
    const messageObject = {
      projectId: this.projectId,
      notes: this.note,
    };
    this.dialog
      .open(NotesComponent, {
        panelClass: 'app-dialog',
        data: messageObject,
        disableClose: true,
        width: '50%',
      })
      .afterClosed()
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        this.fetchWorksheetNotes(this.projectId);
      });
  }

  openViewInstructionsDialog(): void {
    this.dialog
      .open(InstructionsComponent, {
        panelClass: 'app-dialog',
        data: this.worksheetRecords.comments,
        disableClose: true,
        width: '50%',
      })
      .afterClosed()
  }

  openProjectDetailsComponent(title: string, fieldName: string): void {
    if (!this.isReportWriter) {
      const messageObject = {
        projectId: this.projectId,
        title,
        fieldName,
        ovenDate: this.ovenDate,
        wetTestData: this.wetTestData,
        dryTestData: this.dryTestData,
      };
      this.dialog
        .open(ProjectDetailsComponent, {
          panelClass: 'app-dialog',
          data: messageObject,
          disableClose: true,
          width: '50%',
        })
        .afterClosed()
        .pipe(takeUntil(this.destroyed$))
        .subscribe(() => {
          this.fetchWorksheetDetails(this.projectId);
        });
    }
  }

  openSetStatus(): void {
    const messageObject = {
      projectId: this.projectId,
    };
    this.dialog
      .open(SetStatusComponent, {
        panelClass: 'app-dialog',
        data: messageObject,
        disableClose: true,
      })
      .afterClosed()
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        this.fetchWorksheetNotes(this.projectId);
      });
  }

  ngOnDestroy() {
    this.destroyed$.next(false);
    this.destroyed$.complete();
  }

  reDirectUrl() {
    this.router.navigate(['dashboard']);
  }

  assignedDone(): void {
    this.fetchWorksheetNotes(this.projectId);
  }

  review(projectID: string, soilType: string): void {
    const params = {
      f: 'w',
    };

    const navigationExtras: NavigationExtras = {
      queryParams: params,
      state: {
        isShipmentReceived: this.worksheetRecords.project.storageCompartment
      }
    };

    this.formService.updateData(null);
    this.router.navigate([`/review/form/${soilType}/${projectID}`], navigationExtras);
  }

  handleFetchAllHeader(data: {
    asRecivedWorksheets: AdminHeader[];
    moistureWorksheets: AdminHeader[];
    nativeSoilWorksheets: AdminHeader[];
    proctorWorksheets: AdminHeader[];
  }): void {
    this.headerData = data;
  }

  handleAllResNativeWorksheet(data: any): void {
    this.rowData = data;
    this.hasAsReceivedMC = false;
    if (data && data.asRecivedWorksheets) {
        this.hasAsReceivedMC = data.asRecivedWorksheets.some((sample: any) =>
            sample && typeof sample === 'object' &&
            sample.moistureAsReceived !== undefined &&
            sample.moistureAsReceived !== null &&  sample.moistureAsReceived
        );
    }
  }

  lineBreak(textWithNewlines:string){
    return textWithNewlines.replace(/\n/g, '<br>');
  }

  handleAllResPrecastWorksheet(data: any): void {
    this.rowData = data;
  }

  handleFetchPrecastHeader(data: any): void {
    this.headerData = data;
  }

  export() {
    const firstName = this.note?.updatedBy?.firstName || '';
    const lastName = this.note?.updatedBy?.lastName || '';
    const createdAt = this.note?.createdAt;
    const formattedTime = createdAt ? DateTimeUtils.getLocalDateTimeFromUTCDate(createdAt, 'MM/dd/yyyy, h:mm:ss a') : '';
    const notesUpdatedBy = `${firstName} ${lastName} ${formattedTime}`;

    this.exporttableService.openInNewTab(
      this.headerData,
      this.rowData,
      this.worksheetRecords,
      notesUpdatedBy,
      this.noteText,
      this.soilType,
    );
  }

  completeWorksheet(): void {
    this.worksheetService.completeWorksheet(this.projectId).subscribe({
      next: (data) =>  {
        if(data === "Completed") {
          this.snackBar.open('Completed and Assigned to Lab Manager', 'DONE', {
            duration: 3000,
            verticalPosition: 'top',
            panelClass: ['default-snackbar'],
          });
        } else {
          this.snackBar.open('' + data, 'INFORMATION', {
            duration: 3000,
            verticalPosition: 'top',
            panelClass: ['default-snackbar'],
          });
        }
        this.fetchWorksheetDetails(this.projectId);
        this.fetchWorksheetNotes(this.projectId);
      },
      error: (err: any) => console.error(err)
    });
  }

  notifyCustomerConfirmation() {
    if (!this.projectId) {
      console.error('Project ID is missing.');
      return;
    }
    this.worksheetService.confirmMoistureContentNotification(this.projectId)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (response) => {
        },
        error: (error) => {
        },
      });
  }

  printTargetWeights() {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(
        ['/native-soil-print'],
        { queryParams: { projectId: this.projectId } }
      )
    );

    window.open(url, '_blank');
  }

  downloadTRWorksheet(): void {
    if(this.soilType == 'nativesoil') {
      this.nativeSoilTableComponent.downloadTRWorksheet();
    } else {
      this.precastTableComponent.downloadTRWorksheet();
    }
  }

  downloadWorksheetReport(): void {
    this.precastTableComponent.downloadWorksheetReport();
  }
}
